import { FC, useMemo } from "react";
import { Button, TableCell, Tooltip, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  getCategoryColor,
  colors,
  onCopyText,
  productDetailsPageUrl,
} from "common";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { FlexRow } from "components/flex-box";
import Link from "next/link";
import { CategoryItem } from "modules/category/types";
import {
  categoryNameToId,
  convertCategFormat,
} from "utils/categoryConverterUtils";

const useStyles = makeStyles(
  {
    tableCellBorder: {
      borderRight: "0.5px solid black",
      borderColor: colors.primary,
    },
    aHover: {
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline",
      },
    },
  },
  { index: 1 }
);

interface Props {
  categories: CategoryItem[];
  index: number;
  data: any;
}

export const TableCellName: FC<Props> = ({ index, data, categories }) => {
  const classes = useStyles();
  const colorVariant = useMemo(() => (index % 2 ? "100" : "200"), [index]);

  const categName = convertCategFormat(data.category_name);
  const categoryID = categoryNameToId(categName, categories);

  const backgroundColor = useMemo(
    () => getCategoryColor(categoryID || 0)[colorVariant],
    [categoryID, colorVariant]
  );

  return (
    <TableCell style={{ backgroundColor }} className={classes.tableCellBorder}>
      <FlexRow>
        <Tooltip title="Copy">
          <Button
            startIcon={<FileCopyIcon />}
            onClick={() => onCopyText(data?.name || "")}
            style={{ padding: 0, margin: 0 }}
          />
        </Tooltip>
        <Link
          href={productDetailsPageUrl(data?.product_slug, data?.product_uuid)}
          passHref
        >
          <a className={classes.aHover}>
            <Typography
              fontWeight="600"
              fontSize={16}
              color={colors.black}
              sx={{
                display: "-webkit-box",
                overflow: "hidden",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 1,
              }}
            >
              {data?.name}
            </Typography>
          </a>
        </Link>
      </FlexRow>
    </TableCell>
  );
};
